var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluePauseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.33333 9.33358C2.06667 9.33358 2.66667 8.73358 2.66667 8.00024V1.33358C2.66667 0.600244 2.06667 0.000244141 1.33333 0.000244141C0.6 0.000244141 0 0.600244 0 1.33358V8.00024C0 8.73358 0.6 9.33358 1.33333 9.33358ZM5.33333 1.33358V8.00024C5.33333 8.73358 5.93333 9.33358 6.66667 9.33358C7.4 9.33358 8 8.73358 8 8.00024V1.33358C8 0.600244 7.4 0.000244141 6.66667 0.000244141C5.93333 0.000244141 5.33333 0.600244 5.33333 1.33358Z",
    fill: "#A0BFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePauseIcon);
export default __webpack_public_path__ + "static/media/BluePauseIcon.60953ea72d116aea4daf3fe06b2293d1.svg";
export { ForwardRef as ReactComponent };